module.exports = __webpack_public_path__ + "img/pdf2.7019641b.png";